import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import Spinner from "../skills-experience/shared/spinner";
import myProfileLogo from '../../assets/LP_MyProfile.svg';
import profileAdminLogo from '../../assets/profileAdmin.svg';
import platesLogo from '../../assets/PROFILE_LicensePlates.svg';
import ecLogo from '../../assets/PROFILE_EmergencyContact.svg';

const ProfileLanding = ({ userName, profileAdmin, showLicensePlates, setLocation, setMenuOptions }) => {
    const [loading, setLoading ] = useState(true);   
    
    useEffect(() => {
        setMenuOptions("ProfileLanding");
        setLoading(false);
    }, []);

    const handleTileClick = (link) => {
        setLocation(link.url);
    }
        
    const getTiles = () => {
        const options = new Array();

        options.push({
            url: '/Profile/Info',
            title: 'Personal Information',
            image: myProfileLogo
        });
        options.push({
            url: '/Profile/Contacts',
            title: 'Emergency Contacts',
            image: ecLogo
        });
        
        if (showLicensePlates){
            options.push({
                url: '/Profile/Plates',
                title: 'License Plates',
                image: platesLogo
            });
        }

        if (profileAdmin){
            options.push({
                url: '/Profile/Admin',
                title: 'Admin',
                image: profileAdminLogo
            });
        }


        return options;
    }

    const TileMode = () => (
        <>
         <Row className="mb-4">
                <Col className="text-center">
                    <h1>
                        Hello
                        {userName ? " " + userName : ""}!
                    </h1>
                </Col>
        </Row>
        <Row className="d-flex justify-content-center">
                {getTiles().map((link, i) => (
                    <Col key={`tile-${i}`} className="col-12 col-md-3 mx-4 mb-5 text-center">
                        <img
                            onClick={() => handleTileClick(link)}
                            style={{cursor: 'pointer'}}
                            src={link.image}
                            title={link.description}
                            className="w-50 mb-3 link-icon"
                        />
                        <br/>
                        <b className="mb-5">{link.title}</b>
                    </Col>
                ))}
            </Row>
        </>
    );

    return (
        <div className="skills-landing">
            {
                loading ?
                <>
                <Spinner show={loading}/>
                </>
                :
                <TileMode/>
            }
        </div>
    );
};

export default ProfileLanding;
